<script setup lang="ts">
defineProps<{
  clickCount: number;
  lastClickType: string;
}>();
</script>

<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-center gap-2 rounded-lg bg-gray-100 px-3 py-1">
      <span class="text-sm font-medium text-gray-700">Clicks:</span>
      <span class="text-sm font-bold text-gray-900">{{ clickCount }}</span>
    </div>
    <div v-if="lastClickType" class="flex items-center gap-2 rounded-lg bg-blue-100 px-3 py-1">
      <span class="text-sm font-medium text-blue-700">Last:</span>
      <span class="text-sm font-bold text-blue-900">{{ lastClickType }}</span>
    </div>
  </div>
</template>
